import { Button } from "react-bootstrap";
import "../listingTitle/listingtitle.scss";
import { debounce } from "lodash";
import React, { useCallback, useMemo, useState } from "react";

interface CommonSearchOnlyProps {
  title: string;
  buttonTitle: string;
  href: string;
  disRecords: number;
  totalRecords: number;
  searchVal: any;
  setSearchVal: (val: any) => void;
  defaultFilter: any;
  buttonPermission?: boolean;
}

const CommonSearchOnly: React.FC<CommonSearchOnlyProps> = ({
  title,
  buttonTitle,
  href,
  disRecords,
  totalRecords,
  searchVal,
  setSearchVal,
  defaultFilter,
  buttonPermission = true,
}) => {
  const [localSearchText, setLocalSearchText] = useState(searchVal?.searchText ?? "");

  // Create a debounced version of the search handler
  const debouncedSearch = useMemo(
    () => debounce((value: string) => {
      setSearchVal({ ...searchVal, searchText: value });
    }, 500),
    [searchVal, setSearchVal]
  );

  // Handle search input change
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Handle clear button
  const handleClear = useCallback(() => {
    setLocalSearchText("");
    setSearchVal({ ...defaultFilter });
  }, [defaultFilter, setSearchVal]);

  return (
    <div className="listing-title-box">
      <div className="listing-title-info">
        <h2>{title}</h2>
        <p>
          Displaying {disRecords} of {totalRecords} Results
        </p>
      </div>
      <div
        className="listing-searchbar-wrapper"
        style={{ justifyContent: "space-evenly" }}
      >
        <div
          className="listing-searchbar-item-wrapper"
          style={{ flex: "none", display: "contents" }}
        >
          <div className="listing-searchbar-item-box">
            <input
              type="text"
              min={0}
              className="form-control"
              placeholder="Search"
              onChange={handleSearchChange}
              value={localSearchText}
            />
          </div>
          <Button
            type="button"
            variant="outline-secondary"
            className="btn-search"
            onClick={handleClear}
          >
            Clear
          </Button>
        </div>
      </div>
      <div className="listing-action-box">
        {buttonPermission && (
          <div className="action-box">
            <Button variant="primary" href={href}>
              <i className="bi bi-plus"></i>
              {buttonTitle}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonSearchOnly;
